<template>
    <div>
        <div class="col-12"  v-if="products.length">
            <div class="table_header">
                <div class="table_header_box for_desktop_modd">Compare</div>
                <div class="table_header_box">Shape</div>
                <div class="table_header_box">Carat</div>
                <div class="table_header_box">Color</div>
                <div class="table_header_box">Clarity</div>
                <div class="table_header_box">Cut</div>
                <div class="table_header_box for_desktop_modd">Report</div>
                <div class="table_header_box">Price</div>
                <!-- <div class="table_header_box for_desktop_modd d-none"></div> -->
            </div>
        </div>
        <div class="col-12" v-show="!showSkeleton">
            <!-- <TransitionGroup appear name="prod_box_animation" tag="div" class="row listing-container-min-height"> -->
            <div class="row listing-container-min-height">
                <div v-for="data in products" :key="data.uniqueKey">
                    <div v-if="data.isQuiz" class="col-12 mt-2 mb-2" >
                        <ModalLooseDiamondQuiz />
                    </div>
                    <div  :style="{ transitionDelay: `${data.transitionDelayKey * 70}ms` }" v-else>
                        <div class="diamond_table" >
                            <div class="diamond_table_box_mod for_desktop_modd">
                                <div class="checkbox_custom tooltip_box ms-0" @click="addDiamondToCompare(data)">
                                    <span :class="{ 'checked' : data.is_compared_count === 1,  'unchecked' : data.is_compared_count === 0 }"></span>
                                    <label class="mb-0"></label>
                                    <div class="tooltip_text" v-if="data.is_compared_count === 0">Add to Compare</div>
                                    <div class="tooltip_text" v-if="data.is_compared_count === 1">Remove from Compare</div>
                                </div>
                            </div>
                            
                            <div class="mobile-quick-view w-100">
                                <router-link :to="localePath(detailPath(data.slug))" @click="triggerGtag(data)">
                                    <div class="diamond_table_flex">
                                        <div class="diamond_table_box d-flex align-items-center justify-content-center">
                                            <SvgShapeSvg v-if="data.is_fiery_round === 1" type="fiery_round" class="me-2"/>
                                            <SvgShapeSvg :type="data.shape" class="me-2" v-else/>
                                            <span class="for_desktop">{{data.shape}}</span>
                                        </div>
                                        <div class="diamond_table_box">{{data.carat}} Ct</div>
                                        <div class="diamond_table_box">{{data.color}}</div>
                                        <div class="diamond_table_box">{{data.clarity}}</div>
                                        <div class="diamond_table_box">{{data.cut}}</div>
                                        <div class="diamond_table_box for_desktop_modd">{{data.report}}</div>
                                        <div class="diamond_table_box">{{ $formatPrice( data.price ) }}</div>
                                    </div>
                                </router-link>
                                <div  @click.stop="handleQuickView(data)" class="for_mobile quick-view-toggle" ></div>
                            </div>
                        </div>
                    </div>
                </div>
                <CyoLooseQuickViewDiamondQuickView 
                    class="for_mobile"  
                    :data="quickViewProduct" 
                    :openQuickDiamondView="openQuickDiamondView"
                    @closeDiamondQuickView="closeDiamondQuickView"  
                    @openDetailsPage="openDetailsPage"
                />
            </div>
                
            <!-- </TransitionGroup> -->
        </div>
    </div>
</template>


<script setup>

    import {compareStore}  from '@/stores/diamond_compare/diamond_compare';
    import {cyolistStore}  from '@/stores/cyolist/cyolist';

    const router = useRouter()
    const localePath = useLocalePath()
    const quickViewProduct = ref(null)
    const openQuickDiamondView = ref(null)


    const store = cyolistStore();
    const compateStore = compareStore()

    const {$looseViewGtag} = useNuxtApp()

    // Inject moduleSubType
    const moduleSubType = inject('moduleSubType')

    // Computed properties
    const products = computed(() => store.getSettingListingResult())
    const showSkeleton = computed(() => store.getSettingShowSkeleton())

    const triggerGtag = (data) => {
        if (moduleSubType === 'loose') {
            $looseViewGtag(data)
        }
    }

    const detailPath = (slug) => {
        if (['ring', 'earring', 'pendant'].includes(moduleSubType)) {
            return { name: 'cyo-diamond-detail-' + moduleSubType, params: { slug } }
        }
        return { name: 'loose-detail', params: { slug } }
    }

    const addDiamondToCompare = (diamond) => {
        compateStore.addToCompare( { type: moduleSubType, diamond })
            .then((res) => {
                // store.dispatch('toast', { type: 'success', title: res.status, text: res.msg })
            })
    }

    const openDiamondQuickView = (data)=>{
        document.body.classList.add('filter_open');
        quickViewProduct.value = data
        
        nextTick(()=>{
            openQuickDiamondView.value = true
        })
    }

    const closeDiamondQuickView = ()=>{
        document.body.classList.remove('filter_open');
        openQuickDiamondView.value = false
        // setTimeout(()=>{
        //     quickViewProduct.value = null
        // },500)
    }

    const openDetailsPage = (slug)=>{
        closeDiamondQuickView()
        router.push(localePath(detailPath(slug)))   
    }
    const handleQuickView = (data)=>{
        triggerGtag(data)
        openDiamondQuickView(data)
    }
</script>

<style scoped>
.table_header {
    display: flex;
    align-items: center;
    background: #e2e2e2;
}
.table_header_box:first-child, .table_header_box:last-child {
    /* width: 8%; */
}
.table_header_box {
    font-size: 14px;
    color: #212529;
    font-weight: 600;
    width: 12.8%;
    border-right: 3px solid #FFF;
    padding: 5px 15px;
    text-align: left;
    text-align: center;
}
.table_header_box_mod {
    font-size: 14px;
    color: #111827;
    font-weight: 600;
    width: 8%;
    border-right: 3px solid #FFF;
    padding: 5px 15px;
}
.table_header_box:last-child {
    border: 0;
}

/* --------------- */

.diamond_table {
    display: flex;
    align-items: center;
    height: 64px;
    border-bottom: 1px solid #e7eaee;
}
.diamond_table_box {
    font-size: 14px;
    color: #212529;
    font-weight: 400;
    width: 14.28%;
    padding: 5px 18px;
    text-transform: capitalize;
    text-align: center;
}

.diamond_table:nth-child(odd) {
  background: #f9f9f9;
}
.diamond_table:nth-child(even) {
  background: #fff;
}
.diamond_table_box_mod {
    font-size: 14px;
    color: #212529;
    font-weight: 600;
    width: 12.5%;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.diamond_table a {
    width: 100%;
    display: inline-block;
}
.diamond_table_flex {
    width: 100%;
    display: flex;
    align-items: center;
}

@media(max-width: 767px){
    .col-md-12 {
        padding: 0;
    }
    .for_desktop_modd{
        display: none;
    }

    .mobile-quick-view{
        position: relative;
        pointer-events: none;
    }

    .quick-view-toggle{
        width: 100%;
        position: absolute;
        top: 0px;
        left: 0px;
        height: 100%;
        pointer-events: auto;
    }
}


@media(max-width: 1024px){
    .table_header_box, .diamond_table_box{
        width: 16.66%;
        padding: 5px 6px;
    }
    .diamond_table a{
        width: 100%;
    }
}




.fade-enter-active{
  transition: opacity 0.5s ease-in-out;
}

.fade-leave-active{
    display: none;
  transition: opacity 0;
}

.fade-enter,
.fade-leave-to{
  opacity: 0;
}


</style>

